import Logger from '../lib/logger';

class MapDownload extends HTMLElement {
	#NAME = 'MapDownload';
	#abortController;
	#country;
	#download;
	#btn;
	#map;

	constructor() {
		super();
		Logger.info(`${this.#NAME} > constructor`);
		this.#btn = this.querySelector('button');
	}

	connectedCallback() {
		Logger.info(`${this.#NAME} > connectedCallback > ${this.#country}`);
		this.#abortController = new AbortController();
		const { signal } = this.#abortController;
		//
		this.#btn.addEventListener('click', () => {
			console.log('this.#download', this.#download);
			if (this.#download) {
				const href = this.#download;
				const fileName = `${this.#country}.jpg`;
				this.#onDownload(href, fileName);
			} else {
				const { href, fileName } = this.#map.getImage();
				this.#onDownload(href, fileName);
			}
		}, { signal });
	}

	disconnectedCallback() {
		Logger.info(`${this.#NAME} > disconnectedCallback > ${this.#country}`);
		this.#abortController.abort();
		this.#abortController = null;
	}

	static get observedAttributes() {
		return ['country', 'download'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		Logger.info(`${this.#NAME} > attributeChangedCallback > name: ${name} > newValue: ${newValue}`);
		if (name === 'country') {
			this.#country = newValue;
			this.#map = document.querySelector(`interactive-map[country="${this.#country}"]`);
		}
		if (name === 'download') {
			this.#download = newValue;
		}
	}

	#onDownload(href, fileName) {
		fetch(href)
			.then(resp => resp.blob())
			.then(blob => {
				const url = window.URL.createObjectURL(blob);
				const tag = document.createElement('a');
				tag.href = url;
				tag.download = fileName;
				document.body.appendChild(tag);
				tag.click();
				window.URL.revokeObjectURL(url);
				tag.remove();
			})
			.catch(() => this.#altDownload(href, fileName));
	}

	#altDownload(href, fileName) {
		const tag = document.createElement('a');
		tag.href = href;
		tag.target = '_blank';
		tag.download = fileName;
		document.body.appendChild(tag);
		tag.click();
		tag.remove();
	}
}

customElements.define('map-download', MapDownload);
